import { Plus } from 'lucide-react';
import { normalizeTransitionOut, transitionShortLabel } from '@/lib/videoTransitions';

/**
 * Circular + handle between two timeline clips to add / edit the outgoing transition.
 */
export function TimelineTransitionGate({
  leftPx,
  transitionOut = 'cut',
  onClick,
  testId,
}) {
  const active = normalizeTransitionOut(transitionOut) !== 'cut';
  const label = transitionShortLabel(transitionOut);

  return (
    <button
      type="button"
      className="absolute z-40 flex items-center justify-center rounded-full border-2 shadow-lg transition hover:scale-110 active:scale-95"
      style={{
        left: leftPx,
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 22,
        height: 22,
        borderColor: active ? '#fbbf24' : 'rgba(255,255,255,0.55)',
        background: active ? '#f59e0b' : 'rgba(15,23,42,0.92)',
        color: active ? '#111827' : '#f8fafc',
      }}
      title={active ? `Transition: ${label || transitionOut} — click to change` : 'Add transition between scenes'}
      aria-label={active ? `Edit transition ${label || transitionOut}` : 'Add transition'}
      data-testid={testId || 'timeline-transition-gate'}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      {active && label ? (
        <span className="text-[7px] font-black leading-none uppercase tracking-tight px-0.5 truncate max-w-[18px]">
          {label.slice(0, 3)}
        </span>
      ) : (
        <Plus className="w-3 h-3" strokeWidth={3} />
      )}
    </button>
  );
}

export default TimelineTransitionGate;
